import { t } from "@lingui/macro"
export const PageNotFoundView = () => <h1>{t`global.page-not-found`}</h1>
